const SCENARIOS = [
  { label: 'Check-in time', message: 'What time is check-in?' },
  { label: 'Spa booking', message: 'Can I book a massage for tomorrow afternoon?' },
  { label: 'Dinner tonight', message: "What's good for dinner tonight?" },
  { label: 'Kids tomorrow', message: 'What should we do with the kids tomorrow?' },
  { label: 'Report issue', message: "The air conditioning in my room isn't working." },
  { label: 'Late checkout', message: 'Can I check out later than 10am tomorrow?' },
  { label: 'Airport transfer', message: 'Do you offer transfers from Pula airport?' },
  { label: 'Extend stay', message: "We'd love to add one more night — is that possible?" },
];

export default function QuickReplies({ onSelect, disabled }) {
  return (
    <div className="chat-quick-replies">
      {SCENARIOS.map((s) => (
        <button
          key={s.label}
          type="button"
          className="chat-quick-btn"
          disabled={disabled}
          onClick={() => onSelect(s.message)}
        >
          {s.label}
        </button>
      ))}
    </div>
  );
}
